import { CFMixins } from '../../../../mixins';
import { TEXT_COLOR } from '../tokens';
import { getTypeSpec } from '../utils';
export const textInputColor = ({ disabled }) => {
    return disabled ? TEXT_COLOR.DISABLED : TEXT_COLOR.DEFAULT;
};
export const textInputPlaceholderColor = ({ disabled, }) => disabled ? TEXT_COLOR.DISABLED : TEXT_COLOR.PLACEHOLDER;
export const textInputFontSize = ({ fieldSize }) => getTypeSpec(fieldSize).fontSize;
export const textInputTypeSpec = ({ fieldSize }) => CFMixins.typeSpec(getTypeSpec(fieldSize));
